import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function preConfirmDiscount(token,data){
    return await Api.post(REQUEST_URLS.AUTHENTICATION.DISCOUNT_PRE_CONFIRM,data,{
        headers:{
            "Authorization": `Bearer ${token}`
        }
    });
}
export default preConfirmDiscount;